import {
  collectSortedDataKeysFromSubmissions,
  formatSubmissionDataForCsv,
} from './formSubmissions.util';

const trimString = (value) => String(value ?? '').trim();

const getUserCellValue = (person) => {
  const username = trimString(person?.username);
  if (username !== '') {
    return username;
  }
  const name = `${person?.firstName ?? ''} ${person?.lastName ?? ''}`.trim();
  if (name !== '') {
    return name;
  }
  return trimString(person?.docId);
};

const getSubmissionDataObject = (submission) => {
  const data = submission?.data;
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    return {};
  }
  return data;
};

const getSubmittedAtValue = (submission) =>
  typeof submission?.created_at === 'string' ? submission.created_at.trim() : '';

const buildDataCellsForSubmission = (submission, dataKeys, signatureKeys) => {
  const data = getSubmissionDataObject(submission);
  return dataKeys.map((key) =>
    formatSubmissionDataForCsv(data[key], signatureKeys.has(key)),
  );
};

const buildSubmissionCsvRow = (submission, dataKeys, signatureKeys) => {
  const user = getUserCellValue(submission?.person);
  const locationName = trimString(submission?.location_name);
  const submittedAt = getSubmittedAtValue(submission);
  const cells = buildDataCellsForSubmission(submission, dataKeys, signatureKeys);
  return [user, locationName, submittedAt, ...cells];
};

const buildSubmissionsCsvHeaders = (dataKeys) => [
  'User',
  'Location',
  'Submitted',
  ...dataKeys,
];

const buildSubmissionsCsvFilename = (formTitle) => {
  const safeTitle = trimString(formTitle).replaceAll(/\s+/g, '-');
  return safeTitle ? `form-submissions-${safeTitle}.csv` : 'form-submissions.csv';
};

/**
 * Assemble the CSV export payload (`filename`, `headers`, `rows`) for form submissions.
 * @param {{ submissions: readonly object[], signatureKeys: ReadonlySet<string>, formTitle: string }} input
 */
export const buildSubmissionsCsvExportPayload = ({ submissions, signatureKeys, formTitle }) => {
  const dataKeys = collectSortedDataKeysFromSubmissions(submissions);
  const headers = buildSubmissionsCsvHeaders(dataKeys);
  const rows = submissions.map((submission) =>
    buildSubmissionCsvRow(submission, dataKeys, signatureKeys),
  );
  return {
    filename: buildSubmissionsCsvFilename(formTitle),
    headers,
    rows,
  };
};

export const normalizeSubmissionsResponse = (raw) => {
  if (Array.isArray(raw)) {
    return raw;
  }
  if (raw && Array.isArray(raw.data)) {
    return raw.data;
  }
  return [];
};
